// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd233a24","644":"634d07f0","732":"9f166d1d"}[chunkId] + ".chunk.js";
};